import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, CanLoad, Route, RouterStateSnapshot, UrlSegment, UrlTree  } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { UserModel } from '../models/auth/user.model';
import { AuthService } from '../services/auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AdminGuard implements CanActivate, CanActivateChild {

  router: any;
  
  constructor(public authService: AuthService) { }
  
    canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
      return this.canActivate(childRoute, state);
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
      console.log("entra");
      const currentUser = this.authService.usuario;
      console.log(currentUser);
      const fechaAhora = Date.now();
      // if (currentUser.id && fechaAhora <= currentUser.expire) {
        if (currentUser.id) {
        return true;
      }else if (currentUser.expire === 0) {
        return true;
      }
      this.authService.logout();
      return false;
    }

    canLoad(
      route: Route,
      segments: UrlSegment[]): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      return true;
    }
  
}
